export default __webpack_public_path__ + "static/B0046-93de887532897b7c8bebf2e7d05e9afd.png";